import { Fragment } from "react";

export function isReactFragment(variableToInspect) {
    if (variableToInspect.type) {
        return variableToInspect.type === Fragment;
    }
    return variableToInspect === Fragment;
}
